//imports
import { all } from 'redux-saga/effects';

import paymentsListSagas from '../../list/redux/sagas';

//merge sagas
export default function* rootSaga() {
    yield all([
        paymentsListSagas(),
    ]);
}
